import { PageTypes, EXIT_PAGE, TITLE_PAGE } from "../../constants/pageTypes";

export const BLACKLISTED_MICROLESSON_PAGES: PageTypes[] = [TITLE_PAGE, EXIT_PAGE];
export const PAGE_SIZE = 7;
